{
    const links = document.getElementsByClassName('nav-content__left-link')
    const images = document.getElementsByClassName('nav-content__background')
    const navSecondary = document.getElementsByClassName('nav-secondary__title')
    const navSecMenu = document.getElementsByClassName('nav-secondary__nav')

    if (links.length > 1) {
        const imageNodes = Array.from(images)
        Array.from(links).forEach((link, key) => {
            link.addEventListener('mouseenter', () => {
                imageNodes.forEach((node) => {
                    node.classList.remove('active')
                })
                if (imageNodes[key])
                    imageNodes[key].classList.add('active')
            })
        })
    }

    if (navSecondary.length > 0) {
        Array.from(navSecondary).forEach((_, i) => {
            const arrow = document.getElementsByClassName('nav-secondary__arrow')[i]
            const menu = navSecMenu[i]
            if (!arrow || !menu)
                return

            if (menu.classList.contains('nav-secondary__nav-parent')) {
                if (window.innerWidth <= 640)
                    menu.setAttribute('aria-hidden', 'true')
            }
            else {
                menu.setAttribute('aria-hidden', 'true')
            }

            const toggleSecNav = () => {
                if (menu.classList.contains('active')) {
                    menu.classList.remove('active')
                    arrow.setAttribute('aria-expanded', 'false')
                    menu.setAttribute('aria-hidden', 'true')
                }
                else {
                    menu.classList.add('active')
                    arrow.setAttribute('aria-expanded', 'true')
                    menu.setAttribute('aria-hidden', 'false')
                }
            }

            arrow.addEventListener('click', toggleSecNav)
            arrow.addEventListener('keypress', (e) => {
                if (e.charCode === 13)
                    toggleSecNav()
            })
            arrow.addEventListener('touchend', (event) => {
                event.preventDefault()
                toggleSecNav()
            })
        })
    }

    const navTertiaryAll = document.getElementsByClassName('nav-tertiary__link')
    const navTertMenuAll = document.getElementsByClassName('nav-tertiary__nav')

    if (navTertiaryAll.length > 0) {
        const hideMenu = (menu) => {
            menu.style.padding = '0'
            menu.classList.remove('active')
            menu.setAttribute('aria-hidden', 'true')
            menu.style.zIndex = '0'
            menu.style.visibility = 'hidden'
            Array.from(menu.children).forEach((li) => {
                li.style.display = 'none'
            })
        }

        const showMenu = (menu, item) => {
            if (window.innerWidth > 640) {
                menu.style.padding = '0.5rem'
                menu.style.paddingTop = '6rem'
            }
            else {
                menu.style.paddingTop = '2rem'
                menu.style.marginBottom = '-0.5rem'
                const anchor = item.querySelector('a')
                if (anchor)
                    anchor.style.marginBottom = '1rem'
            }

            menu.style.visibility = 'visible'
            menu.classList.add('active')
            menu.setAttribute('aria-hidden', 'false')
            menu.style.zIndex = '-1'
            item.style.zIndex = '10'
            Array.from(menu.children).forEach((li) => {
                li.style.display = ''
            })
        }

        Array.from(navTertiaryAll).forEach((item) => {
            const menu = item.querySelector('.nav-tertiary__nav')
            const arrow = item.querySelector('.nav-tertiary__arrow')
            if (!menu || !arrow)
                return

            menu.setAttribute('aria-hidden', 'true')
            menu.style.visibility = 'hidden'
            menu.style.padding = '0'
            Array.from(menu.children).forEach((li) => {
                li.style.display = 'none'
            })

            const toggleTertNav = () => {
                if (menu.classList.contains('active')) {
                    hideMenu(menu)
                    arrow.setAttribute('aria-expanded', 'false')
                    arrow.classList.remove('active')
                    item.style.zIndex = '0'

                    if (window.innerWidth <= 640) {
                        Array.from(navTertiaryAll).forEach((navItem) => {
                            const anchor = navItem.querySelector('a')
                            if (anchor)
                                anchor.style.marginBottom = '0'
                            navItem.style.marginBottom = '0.5rem'
                        })
                    }
                    else {
                        Array.from(navTertiaryAll).forEach((navItem) => {
                            navItem.style.marginBottom = '0rem'
                        })
                    }

                    Array.from(navTertMenuAll).forEach((navMenu) => {
                        navMenu.style.marginBottom = '0'
                    })
                }
                else {
                    Array.from(navTertMenuAll).forEach((navMenu) => {
                        hideMenu(navMenu)
                    })
                    Array.from(document.getElementsByClassName('nav-tertiary__arrow')).forEach((navArrow) => {
                        navArrow.setAttribute('aria-expanded', 'false')
                        navArrow.classList.remove('active')
                    })
                    Array.from(navTertiaryAll).forEach((navItem) => {
                        navItem.style.zIndex = '0'
                    })
                    Array.from(navTertMenuAll).forEach((navMenu) => {
                        navMenu.style.paddingTop = '0'
                    })

                    showMenu(menu, item)
                    arrow.setAttribute('aria-expanded', 'true')
                    arrow.classList.add('active')
                }
            }

            arrow.addEventListener('click', toggleTertNav)
            arrow.addEventListener('keypress', (e) => {
                if (e.charCode === 13)
                    toggleTertNav()
            })
            arrow.addEventListener('touchend', (event) => {
                event.preventDefault()
                toggleTertNav()
            })
        })
    }
}

const navBar = document.querySelector('.nav')
const navMain = document.querySelector('.nav-content__wrapper')
const mainContent = document.querySelector('.main-content')
const menuToggle = document.querySelector('.nav__menu')
const searchToggle = document.querySelector('.nav__icon-search')
const searchPanel = document.querySelector('.nav__search-wrapper')

const setMenuOpen = (isOpen) => {
    navMain?.classList.toggle('active', isOpen)
    navBar?.classList.toggle('open', isOpen)
    menuToggle?.classList.toggle('active', isOpen)
    menuToggle?.setAttribute('aria-expanded', String(isOpen))
    mainContent?.setAttribute('aria-hidden', String(isOpen))
    document.body.classList.toggle('menu--open', isOpen)
    const label = menuToggle?.querySelector('.nav__menu-text')
    if (label)
        label.textContent = isOpen ? '\u00a0\u00a0Close' : '\u00a0\u00a0Menu'
}

const setSearchOpen = (isOpen) => {
    searchPanel?.classList.toggle('active', isOpen)
    searchToggle?.classList.toggle('active', isOpen)
    searchToggle?.setAttribute('aria-expanded', String(isOpen))
    document.body.classList.toggle('search--open', isOpen)
}

// Use the same state transitions for pointer and keyboard activation.
const bindToggle = (element, toggle) => {
    element?.addEventListener('click', toggle)
    element?.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            toggle()
        }
    })
}

bindToggle(menuToggle, () => {
    if (!navMain)
        return
    const isOpen = !navMain.classList.contains('active')
    setSearchOpen(false)
    setMenuOpen(isOpen)
    if (isOpen)
        navMain.scrollTo(0, 0)
})

bindToggle(searchToggle, () => {
    if (!searchPanel)
        return
    const isOpen = !searchPanel.classList.contains('active')
    setMenuOpen(false)
    setSearchOpen(isOpen)
    if (isOpen)
        searchPanel.querySelector('.results__input')?.focus()
})

document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape')
        return
    if (navMain?.classList.contains('active')) {
        setMenuOpen(false)
        menuToggle?.focus()
    }
    else if (searchPanel?.classList.contains('active')) {
        setSearchOpen(false)
        searchToggle?.focus()
    }
})
